/**
 * Mock 书籍分类管理 API
 *
 * 提供 Mock 书籍分类的 CRUD 操作
 */

import httpRequest from '@/utils/api'
import type {
  Category,
  CreateCategoryRequest,
  UpdateCategoryRequest,
  CategoryListResponseData,
} from '@/types/mock/category'

enum API {
  categories = '/mock-api/admin/categories',
  category = '/mock-api/admin/categories/:categoryId',
}

/**
 * 获取所有分类（包括禁用的）
 *
 * @returns 分类列表响应
 */
export const getAllCategoriesAPI = () => {
  return httpRequest.get<CategoryListResponseData>({
    url: API.categories,
  })
}

/**
 * 创建分类
 *
 * @param data 创建请求数据
 * @returns 分类详情响应
 */
export const createCategoryAPI = (data: CreateCategoryRequest) => {
  return httpRequest.post<Category>({
    url: API.categories,
    data,
  })
}

/**
 * 更新分类
 *
 * @param categoryId 分类 ID
 * @param data 更新请求数据
 * @returns 分类详情响应
 */
export const updateCategoryAPI = (
  categoryId: number,
  data: UpdateCategoryRequest
) => {
  return httpRequest.put<Category>({
    url: API.category.replace(':categoryId', categoryId.toString()),
    data,
  })
}

/**
 * 删除分类（软删除）
 *
 * @param categoryId 分类 ID
 * @returns 删除响应
 */
export const deleteCategoryAPI = (categoryId: number) => {
  return httpRequest.delete<void>({
    url: API.category.replace(':categoryId', categoryId.toString()),
  })
}

